import { render, staticRenderFns } from "./TagSuggestion.vue?vue&type=template&id=e4353b84&"
import script from "./TagSuggestion.vue?vue&type=script&lang=js&"
export * from "./TagSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./TagSuggestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4353b84')) {
      api.createRecord('e4353b84', component.options)
    } else {
      api.reload('e4353b84', component.options)
    }
    module.hot.accept("./TagSuggestion.vue?vue&type=template&id=e4353b84&", function () {
      api.rerender('e4353b84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TagSuggestion.vue"
export default component.exports